export default "/assets/heart-pink-solid.svg";